import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../../../components/Button";
import DialogTemplate from "../../../components/DialogTemplate";

const useStyles = makeStyles((theme) => ({
  title: {
    padding: theme.spacing(1),
  },
  filtersErrorDialogContent: {
    paddingTop: 0,
    padding: theme.spacing(3),
  },
  actions: {
    paddingTop: 0,
    padding: theme.spacing(3),
  },
}));

function FiltersErrorDialog(props) {
  const { open, onClose, ...other } = props;
  const classes = useStyles();

  return (
    <DialogTemplate
      title="Please choose different filters"
      open={open}
      onClose={onClose}
      className={classes.filtersErrorDialogContent}
      DialogTitleProps={{ className: classes.title }}
      DialogActionsProps={{ className: classes.actions }}
      actions={
        <React.Fragment>
          <Button variant="contained" onClick={onClose}>
            OK
          </Button>
        </React.Fragment>
      }
      {...other}
    >
      <div>You’ve filtered out too many respondents. To maintain anonymity, results will only display if there are 5 or more respondents.</div>
    </DialogTemplate>
  );
}

FiltersErrorDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default FiltersErrorDialog;



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/FiltersErrorDialog.jsx